<template>
  <div>
    <b-navbar shadow spaced class="has-background-white">
      <template slot="brand">
        <div class="level mb-0">
          <div class="level-left">
            <div class="level-tem">
              <b-navbar-item>
                <menu-general></menu-general>
              </b-navbar-item>
            </div>
            <div class="level-tem">
              <b-navbar-item tag="router-link" :to="constante.PAGE_DEFAULT">
                <img
                  src="@/assets/images/accueilLogo.svg"
                  alt="Affixe2.0"
                  class="ml-15">
              </b-navbar-item>
            </div>
            <div class="level-right"></div>
          </div>
        </div>
      </template>

      <template slot="end">
        <b-navbar-item class="icon-header"
          v-if="showItemPanier"
          @click="isModalViderPanierOpen = true">
          <b-tooltip
            :label="$t('header.viderPanier.tooltip')"
            position="is-bottom">
            <b-icon icon="cart-off" size="mdi-24px"></b-icon>
          </b-tooltip>
        </b-navbar-item>
        <b-navbar-item
          v-if="showItemPanier"
          tag="router-link" :to="{ path: '/panier' }">
          <div class="level">
            <div class="level-left">
              <b-icon icon="cart-outline"
                size="mdi-24px"></b-icon>
            </div>
            <div class="level-right ml-10">
              <div class="hero">
                <div class="has-text-default is-size-8">
                  <p class="mr-10">{{$t('header.cart')}} ({{ panneauxActif.length }})</p>
                </div>
                <div>
                  <p class="has-text-grid-1 is-size-7 has-text-weight-bold">
                    {{totalPanier === -1 ? $t('header.vide') : formatNombre(totalPanier)}}
                  </p>
                </div>
              </div>
              <div class="level-item" v-if="afficheSousC">
                <p class="has-text-default is-size-8">
                  <span> {{ $t('header.dont') }} </span>
                  <strong>{{formatNombre(totalSousContrat)}}</strong> <br>
                  <span> {{ $t('header.sousContrat') }} </span>
                </p>
              </div>
            </div>
          </div>
        </b-navbar-item>
        <b-navbar-item tag="div" class="devider-header"></b-navbar-item>
        <b-navbar-item tag="div" class="pointer">
          <b-dropdown aria-role="menu" position="is-bottom-left">
            <avatar
              username="Jane Doe"
              :size="40"
              src="https://blog-fr.orson.io/wp-content/uploads/2017/06/jpeg-ou-png.jpg"
              slot="trigger"/>

            <b-dropdown-item
              aria-role="listitem"
              @click="logout">
              {{$t('header.logout')}}
            </b-dropdown-item>
          </b-dropdown>
        </b-navbar-item>
      </template>
    </b-navbar>
    <b-modal
      v-model="isModalViderPanierOpen"
      :width="480"
      aria-role="dialog"
      trap-focus
      aria-modal>
      <modal-vider-panier
        @annuler="isModalViderPanierOpen = false"
        @confirmer="viderPanier"/>
    </b-modal>
  </div>
</template>

<script>
  import Avatar from 'vue-avatar';
import { auth } from '@/plugins/firebase';
import { auth as authSuivi } from '@/plugins/firebaseSuivi';
import { createNamespacedHelpers } from 'vuex';
import { PAGE_DEFAULT } from '@/router/routerConf';
import ModalViderPanier from '@/components/general/ModalViderPanier';
import { formatNombre } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';
import { genererPanneauHonoraireForfaitaire } from '@/services/recommandation/gestionHonoraireFortaitaire';
import MenuGeneral from './menu';

const User = createNamespacedHelpers('user');
const Recommandations = createNamespacedHelpers('recommandations');

export default {
  components: {
    Avatar,
    MenuGeneral,
    ModalViderPanier,
  },
  data() {
    return {
      modalIsActive: false,
      isModalViderPanierOpen: false,
      constante: { PAGE_DEFAULT },
    };
  },
  methods: {
    ...User.mapActions({
      actionsLogOut: 'logOut',
    }),
    ...Recommandations.mapActions({
      resetStoreRecom: 'resetStore',
    }),
    async logout() {
      try {
        await this.actionsLogOut();
        await auth.signOut();
        await authSuivi.signOut();
        this.$router.push('/connexion');
      } catch (error) {
        gestionErreur(`Erreur lors de la déconnexion de l'utilisateur ${this.userId}`, error);
      }
    },
    formatNombre: (val) => formatNombre(val),
    goToHome() {
      if (this.$route.name === PAGE_DEFAULT.name) return;
      this.$router.push(PAGE_DEFAULT);
    },
    async viderPanier() {
      this.isModalViderPanierOpen = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.resetStoreRecom();
        this.goToHome();
      } finally {
        loadingComponent.close();
      }
    }
  },
  computed: {
    ...User.mapGetters({
      userId: 'userId',
    }),
    ...Recommandations.mapGetters({
      panneaux: 'panneaux',
      recommandation: 'recommandation',
      honoraireForfaitaire: 'honoraireForfaitaire',
    }),
    panneauxActif() {
      const data = this.panneaux.filter(el => el.actif);
      if (this.honoraireForfaitaire) {
        const panneauHonoraireForfaitaire = genererPanneauHonoraireForfaitaire(this.honoraireForfaitaire);
        data.push(panneauHonoraireForfaitaire);
      }
      return data;
    },
    afficheSousC() {
      return this.panneauxActif.some(el => el.estPanneauSousContrat);
    },
    totalPanier() {
      if (!this.recommandation) return -1;
      return (this.recommandation.montantHt || 0) + this.totalSousContrat;
    },
    totalSousContrat() {
      return this.panneauxActif
        .filter(el => el.estPanneauSousContrat)
        .reduce((total, panneau) => {
          return total + panneau.budgets.reduce((sum, b) => sum + (b.prixTotal || 0), 0);
        }, 0);
    },
    showItemPanier() {
      return !!this.recommandation && this.$route.name !== 'detail-recommandation';
    }
  },
};
</script>
